const messages = {
  title: "Loja De Recompensas",
  description: "Aqui poderá trocar os seus pontos por recompensas de diferentes categorias. <br>A seleção de produtos é atualizada regularmente. <br> Esperamos que goste da experiência.",
  sort: {
    asc: "Ordenar por: Preço mais baixo",
    desc: "Ordenar por: Preço mais elevado",
  },
  productSearchBox: {
    from: "pontos desde",
    to: "pontos até",
  },
  noProducts: "Os critérios de pesquisa não produziram qualquer resultado",
  quantity: "Quantidade",
  search: "Procurar",
  perPage: "Itens por página",
  timeUnavailable: "Atualmente não disponível de momento",
  product: "PRODUTO",
  cart: {
    pointsPerUnit: "Pontos por unidade",
    pointsSum: "Total de pontos",
  },
  action: "Ação",
  pointsTotal: "Total",
  cartRemainPoints: "Pontos restantes",
  shoppingCart: "Carrinho de compras",
  emptyCart: "O carrinho de compras está vazio.",
  attributes: "Características",
  selectAddressP: "Por favor, selecione a sua morada de entrega",
  orderDelivery: "Morada de entrega",
  selectedProducts: "Produtos selecionados",
  orderSummary: "Resumo do pedido",
  contactPerson: "Pessoa de contato",
  selectedAddress: "Morada de entrega selecionada",
  order: {
    success: "Obrigado! O seu pedido foi realizado com sucesso. A confirmação será enviada para o seu email em poucos minutos. Fique atento.",
    description: "Encontre aqui todas as informações sobre as suas encomendas na loja de prémios.",
    info: "Aqui pode encontrar uma visão geral das suas encomendas.",
    date: "Facha de pedido",
    number: "Número de pedido",
    status: {
      created: "Pago",
      confirm_order: "Confirmar encomenda",
      ready_for_shipment: "Pronto para envio",
      rejected: "Cancelado",
      processed: "Processado",
      shipped: "Enviado",
      returned: "Devolvido",
      finished: "Concluído",
    },
    anyOrder: "Sem pedidos",
    products: "Produtos",
    quantity_short: "pcs",
    itemRemoved: "não entregável",
  },
  orders: "Encomendas",
  notEnoughPoints: "Não há pontos suficientes disponíveis.",
  statusText: "Estado",
  outOfStock: "Atualmente sem stock",
  productUnavailable: "Este produto já não está disponível.",
  deletedProductsTitle: "Produtos já não disponíveis",
  deletedProductsMessage: "Os seguintes produtos já não estão disponíveis. Remova-os do carrinho para continuar.",
  removeSelected: "Remover seleção",
  clearCart: "Esvaziar carrinho",
  removeSelectedConfirm: "Remover os produtos selecionados do carrinho?",
  clearCartConfirm: "Remover todos os produtos do carrinho?",
  incompleteAddress: {
    firstName: "Adicione um nome próprio à morada de entrega",
    lastName: "Adicione um apelido à morada de entrega",
    company: "Adicione um nome de empresa à morada de entrega",
    street: "Adicione uma rua e número à morada de entrega",
    postalCode: "Adicione um código postal à morada de entrega",
    city: "Adicione uma cidade à morada de entrega",
    country: "Adicione um país à morada de entrega",
    phone: "Adicione um número de telefone à morada de entrega",
  },
  placeOrder: "Encomenda vinculativa",
  toOrderDelivery: "Continuar para o endereço de entrega",
  toOrderSummary: "Para o resumo da encomenda",
  productImg: "Imagem do produto",
  selectAddressBtn: "Escolher endereço",
  perPgae: "Itens por página",
  categories: {
    advertising: {
      title: "Material publicitário",
      desc: "Participe diretamente aqui na plataforma e garanta <br/> 40 pontos extra para o clube de recompensas.",
    },
    rewards: {
      title: "Recompensas exclusivas",
      desc: "Descubra a oferta de bónus no nosso centro de formação ou na sua localização.",
    },
    tools: {
      title: "Ferramentas de oficina",
      desc: "Use os seus pontos para formações de terceiros <br/> e reduza os seus custos.",
    },
    trainings: {
      title: "Formação e cursos",
      desc: "Descubra a oferta de bónus no nosso centro de formação ou na sua localização.",
    },
    salesroom: {
      title: "Sala de vendas",
      desc: "Prepare a sala de vendas e ofereça aos clientes uma estadia agradável.",
    },
    hunter: {
      title: "Hunter",
      desc: "Troque pontos por equipamento de oficina Hunter atrativo.",
    },
  },
  bestSold: "Mais vendidos",
  seasonal: "Sazonal",
  affordable: "Quase lá",
  forPoints: "por {points} pontos",
  reachedPoints: "Pontos necessários atingidos",
  remainingPoints: "Faltam {points} pontos",
  favoriteProducts: {
    description: "Aqui encontrará os produtos que guardou.",
  },
  categoryPageDescriptionFallback: "Material para a oficina ou outros produtos de qualidade com o logótipo Bridgestone para a sua empresa",
  variant: "Variantes selecionáveis",
};
export default {
  messages,
};
